/**
 * Card rank values matching pokerkit naming conventions
 */
export enum Rank {
  ACE = 'A',
  DEUCE = '2',
  TREY = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
  EIGHT = '8',
  NINE = '9',
  TEN = 'T',
  JACK = 'J',
  QUEEN = 'Q',
  KING = 'K',
  JOKER = '*',
}

/**
 * Card suit values matching pokerkit naming conventions
 */
export enum Suit {
  CLUB = 'c',
  DIAMOND = 'd',
  HEART = 'h',
  SPADE = 's',
  WILD = 'w',
}

/**
 * OFC board row positions
 */
export enum RowPosition {
  FRONT = 'front',
  MIDDLE = 'middle',
  BACK = 'back',
}

/**
 * OFC game variants
 */
export enum OFCVariant {
  OpenFaceChineseStandard = 'OpenFaceChineseStandard',
  OpenFaceChinesePineapple = 'OpenFaceChinesePineapple',
  OpenFaceChinesePineappleFantasy = 'OpenFaceChinesePineappleFantasy',
  OpenFaceChineseDeuceToSeven = 'OpenFaceChineseDeuceToSeven',
  OpenFaceChinesePineappleDeuceToSeven = 'OpenFaceChinesePineappleDeuceToSeven',
  OpenFaceChineseJoker = 'OpenFaceChineseJoker',
  OpenFaceChinesePineappleJoker = 'OpenFaceChinesePineappleJoker',
}

/**
 * Acting mode for card placement
 */
export enum ActingMode {
  SEQUENTIAL = 'sequential',
  SIMULTANEOUS = 'simultaneous',
}

/**
 * Hand classification labels matching pokerkit naming
 */
export enum Label {
  HIGH_CARD = 'High card',
  ONE_PAIR = 'One pair',
  TWO_PAIR = 'Two pair',
  THREE_OF_A_KIND = 'Three of a kind',
  STRAIGHT = 'Straight',
  FLUSH = 'Flush',
  FULL_HOUSE = 'Full house',
  FOUR_OF_A_KIND = 'Four of a kind',
  STRAIGHT_FLUSH = 'Straight flush',
  ROYAL_FLUSH = 'Royal flush',

  FRONT_HIGH_CARD = 'Front high card',
  FRONT_ONE_PAIR = 'Front one pair',
  FRONT_THREE_OF_A_KIND = 'Front three of a kind',
}
